const DEBUG = true;

const script = document.currentScript;

const data = {
    customer_email: script.getAttribute('data-customer-email'),
    customer_id: script.getAttribute('data-customer-id'),
    permanent_domain: script.getAttribute('data-permanent-domain')
}

if(DEBUG) console.table(data);

if(DEBUG) console.log("exponea start");

window.exponeaLoaded = false;

const getStartDataAndStartExponea = () => {
    if(DEBUG) console.log("exponia running start");

    window.exponeaLoaded = true;
    !function(e,n,t,i,o,r){function c(e){if("number"!=typeof e)return e;var n=new Date;return new Date(n.getTime()+1e3*e)}var a=4e3,s="xnpe_async_hide";function p(e){return e.reduce((function(e,n){return e[n]=function(){e._.push([n.toString(),arguments])},e}),{_:[]})}function m(e,n,t){var i=t.createElement(n);i.src=e;var o=t.getElementsByTagName(n)[0];return o.parentNode.insertBefore(i,o),i}function u(e){return"[object Date]"===Object.prototype.toString.call(e)}r.target=r.target||"https://api.exponea.com",r.file_path=r.file_path||r.target+"/js/exponea.min.js",o[n]=p(["anonymize","initialize","identify","update","track","trackLink","trackEnhancedEcommerce","getHtml","showHtml","showBanner","showWebLayer","ping","getAbTest","loadDependency","getRecommendation","reloadWebLayers"]),o[n].notifications=p(["isAvailable","isSubscribed","subscribe","unsubscribe"]),o[n]["snippetVersion"]="v2.3.0",function(e,n,t){e[n]["_"+t]={},e[n]["_"+t].nowFn=Date.now,e[n]["_"+t].snippetStartTime=e[n]["_"+t].nowFn()}(o,n,"performance"),function(e,n,t,i,o,r){e[o]={sdk:e[i],sdkObjectName:i,skipExperiments:!!t.new_experiments,sign:t.token+"/"+(r.exec(n.cookie)||["","new"])[1],path:t.target}}(o,e,r,n,i,RegExp("__exponea_etc__"+"=([\\w-]+)")),function(e,n,t){m(e.file_path,n,t)}(r,t,e),function(e,n,t,i,o,r,p){if(e.new_experiments){!0===e.new_experiments&&(e.new_experiments={});var f,l=e.new_experiments.hide_class||s,_=e.new_experiments.timeout||a,d=encodeURIComponent(r.location.href.split("#")[0]);e.cookies&&e.cookies.expires&&("number"==typeof e.cookies.expires||u(e.cookies.expires)?f=c(e.cookies.expires):e.cookies.expires.tracking&&("number"==typeof e.cookies.expires.tracking||u(e.cookies.expires.tracking))&&(f=c(e.cookies.expires.tracking))),f&&f<new Date&&(f=void 0);var x=e.target+"/webxp/"+n+"/"+r[t].sign+"/modifications.min.js?http-referer="+d+"&timeout="+_+"ms"+(f?"&cookie-expires="+Math.floor(f.getTime()/1e3):"");"sync"===e.new_experiments.mode&&r.localStorage.getItem("__exponea__sync_modifications__")?function(e,n,t,i,o){t[o][n]="<"+n+' src="'+e+'"></'+n+">",i.writeln(t[o][n]),i.writeln("<"+n+">!"+o+".init && document.writeln("+o+"."+n+'.replace("/'+n+'/", "/'+n+'-async/").replace("><", " async><"))</'+n+">")}(x,n,r,p,t):function(e,n,t,i,o,r,c,a){r.documentElement.classList.add(e);var s=m(t,i,r);function p(){o[a].init||m(t.replace("/"+i+"/","/"+i+"-async/"),i,r)}function u(){r.documentElement.classList.remove(e)}s.onload=p,s.onerror=p,o.setTimeout(u,n),o[c]._revealPage=u}(l,_,x,n,r,p,o,t)}}(r,t,i,0,n,o,e),function(e,n,t){e[n].start=function(i){i&&Object.keys(i).forEach((function(e){return t[e]=i[e]})),e[n].initialize(t)}}(o,n,r)}(document,"exponea","script","webxpClient",window,{
        "target": "//api.uk.exponea.com",
        "token": "65855596-70b5-11ed-b735-4a8774af5ee0",
        "track": {
          "visits": true,
        },
    });

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return undefined;
    }

    var customer = {};
    var cart_id = getCookie('cart'); //default Shopify cookie name is "cart"
    if (cart_id) customer.cart_id = cart_id;

    if(data.customer_email && data.customer_id){
        customer.email_id = data.customer_email;
        customer.shopify_id = data.customer_id;
    }

    let exponea_start_data = {
        "customer": customer,
        "track": {
            "visits": true,
        }
    }
    if(data.permanent_domain){

        exponea_start_data.track.default_properties = {
            "domain": data.permanent_domain
        }
    }

    exponea.start(exponea_start_data);

    // const evt = new CustomEvent("bfb-exponea-loaded", { exponea });
    // window.dispatchEvent(evt);
}

const checkAndRunExponeaOnLoad = () => {
    if(DEBUG) console.log("checkAndRunExponeaOnLoad");

    let cookieValue = JSON.parse(window.atob(getCookie("_pandectes_gdpr")))

    // let preferences = cookieValue.preferences
    let allowed = cookieValue.status == "allow" || cookieValue.status == "custom"
    
    if (!allowed){
        if(DEBUG) console.log("null preferences");
    }else{
        if(DEBUG) console.log("Running exponea on start");

        getStartDataAndStartExponea()
    }    
}

window.addEventListener("PandectesEvent_OnConsent", (event) => {
    if(DEBUG) console.log("PandectesEvent_OnConsent");

    const preferences = event.detail.preferences;
    const p1 = (preferences & 1) === 0;
    const p2 = (preferences & 2) === 0;
    const p4 = (preferences & 4) === 0;
    const consentData = {
        essential: true,
        functional: p1,
        performance: p2,
        marketing: p4
    };

    if (window.exponeaLoaded || !consentData.functional) {
        return;
    }

    getStartDataAndStartExponea()
});

checkAndRunExponeaOnLoad()
